<template>
  <div class="home">
    <Loading v-if="loading" :text="$t('finish-loading')"></Loading>
    <h3 v-if="error">{{ error }}</h3>
  </div>
</template>

<script>
import Loading from "../components/blocks/Loading";
const axios = require("axios").default;
import { nSteps, redirectToUnselectedStepIfAny } from "@/utils/steps.js";
import { BACKEND_URL } from "@/utils/config";
import { localizeUrl } from "@/utils/localizeUrl";

export default {
  name: "Finish",
  components: { Loading },
  data() {
    return {
      loading: true,
      error: null,
      calcData: this.$store.state.data
    };
  },
  mounted() {
    let redirected = redirectToUnselectedStepIfAny(
      nSteps(),
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
    if (redirected) {
      return;
    }

    setTimeout(this.getData, 2000); // Look busy for a bit :)
  },
  methods: {
    async getData() {
      try {
        const resp = await axios.post(BACKEND_URL + "/calculator-data", {
          inputData: this.calcData,
          lang: this.$i18n.locale
        });
        if (resp.status !== 200) {
          throw new Error(resp.status);
        }
        this.$router.push(localizeUrl("summary", this.$i18n.locale) + `?id=${resp.data.dataId}`);
      } catch (error) {
        this.loading = false;
        this.error =
          "Something went wrong... Please try refreshing the page or contact our support.";
        console.error(error);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";
.home {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.title {
  padding-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
.get-started-btn {
  margin-top: 20px;
}
.hero-image {
  max-width: 600px;
}
.product-title {
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 20px;
  color: $color-primary;
}
</style>
